export const SETUP_AMITY_USER_SESSION = "SetupUserSession";
export const SETUP_AMITY_USER_SESSION_SUCCESS = "SetupUserSession.Success";
export const SETUP_AMITY_USER_SESSION_FAILURE = "SetupUserSession.Failure";
export const BAN_USER = "BanUser";
export const BAN_USER_SUCCESS = "BanUser.Success";
export const BAN_USER_FAILURE = "BanUser.Failure";
export const SUBSCRIBE_TO_COMMUNITY = "SubscribeToCommunity";
export const RESET_PRAYER_FEATURE = "ResetPrayerFeature";
export const AMITY_CONNECTION_CHANGED = "AmityConnection.Changed";
export const UPDATE_AMITY_USER_ROLE = "UpdateAmityUserRole";
export const PRAYER_WALL_TAB_CHANGED = "PrayerWallTab.Changed";
export const PRAYER_WALL_ENTERED = "PrayerWall.Entered";
export const PRAYER_WALL_LEFT = "PrayerWall.Left";
export const POST_PRAYER = "PostPrayer";
export const POST_PRAYER_SUCCESS = "PostPrayer.Success";
export const POST_PRAYER_FAILURE = "PostPrayer.Failure";
export const EDIT_PRAYER = "EditPrayer";
export const EDIT_PRAYER_SUCCESS = "EditPrayer.Success";
export const EDIT_PRAYER_FAILURE = "EditPrayer.Failure";
export const GET_PRAYER_OF_THE_WEEK = "GetPrayerOfTheWeek";
export const GET_PRAYER_OF_THE_WEEK_SUCCESS = "GetPrayerOfTheWeek.Success";
export const GET_PRAYER_OF_THE_WEEK_FAILURE = "GetPrayerOfTheWeek.Failure";
export const GET_ALL_PRAYERS = "GetAllPrayers";
export const GET_ALL_PRAYERS_SUCCESS = "GetAllPrayers.Success";
export const GET_ALL_PRAYERS_FAILURE = "GetAllPrayers.Failure";
export const UPDATE_LAST_LOAD_TIME = "UpdateLastLoadTime";
export const GET_MY_PRAYERS = "GetMyPrayers";
export const GET_MY_PRAYERS_SUCCESS = "GetMyPrayers.Success";
export const GET_MY_PRAYERS_FAILURE = "GetMyPrayers.Failure";
export const GET_NEXT_PRAYERS = "GetNextPrayers";
export const GET_NEXT_PRAYERS_COMPLETED = "GetNextPrayersCompleted";
export const REFRESH_ALL_PRAYERS = "RefreshAllPrayers";
export const REFRESH_MY_PRAYERS = "RefreshMyPrayers";
export const DELETE_PRAYER = "DeletePrayer";
export const DELETE_PRAYER_SUCCESS = "DeletePrayer.Success";
export const DELETE_PRAYER_FAILURE = "DeletePrayer.Failure";
export const NOTIFY_DELETED_PRAYER = "NotifyDeletedPrayer";
export const NOTIFY_DELETED_PRAYER_SUCCESS = "NotifyDeletedPrayer.Success";
export const NOTIFY_DELETED_PRAYER_FAILURE = "NotifyDeletedPrayer.Failure";
export const ADD_PRAYER_REACTION = "AddPrayerReaction";
export const ADD_PRAYER_REACTION_SUCCESS = "AddPrayerReaction.Success";
export const ADD_PRAYER_REACTION_FAILURE = "AddPrayerReaction.Failure";
export const REMOVE_PRAYER_REACTION = "RemovePrayerReaction";
export const REMOVE_PRAYER_REACTION_SUCCESS = "RemovePrayerReaction.Success";
export const REMOVE_PRAYER_REACTION_FAILURE = "RemovePrayerReaction.Failure";
export const GET_COMMENTS = "GetComments";
export const GET_COMMENTS_SUCCESS = "GetComments.Success";
export const GET_COMMENTS_FAILURE = "GetComments.Failure";
export const GET_COMMENT = "GetComment";
export const GET_COMMENT_SUCCESS = "GetComment.Success";
export const GET_COMMENT_FAILURE = "GetComment.Failure";
export const ADD_COMMENT = "AddComment";
export const ADD_COMMENT_SUCCESS = "AddComment.Success";
export const ADD_COMMENT_FAILURE = "AddComment.Failure";
export const EDIT_COMMENT = "EditComment";
export const EDIT_COMMENT_SUCCESS = "EditComment.Success";
export const EDIT_COMMENT_FAILURE = "EditComment.Failure";
export const DELETE_COMMENT = "DeleteComment";
export const DELETE_COMMENT_SUCCESS = "DeleteComment.Success";
export const DELETE_COMMENT_FAILURE = "DeleteComment.Failure";
export const ADD_COMMENT_REACTION = "AddCommentReaction";
export const ADD_COMMENT_REACTION_SUCCESS = "AddCommentReaction.Success";
export const ADD_COMMENT_REACTION_FAILURE = "AddCommentReaction.Failure";
export const REMOVE_COMMENT_REACTION = "RemoveCommentReaction";
export const REMOVE_COMMENT_REACTION_SUCCESS = "RemoveCommentReaction.Success";
export const REMOVE_COMMENT_REACTION_FAILURE = "RemoveCommentReaction.Failure";
export const GET_NOTIFICATION_BADGE = "GetNotificationBadge";
export const GET_NOTIFICATION_BADGE_SUCCESS = "GetNotificationBadge.Success";
export const GET_NOTIFICATION_BADGE_FAILURE = "GetNotificationBadge.Failure";
export const POST_NOTIFICATION_BADGE_ASREAD = "PostNotificationBadgeAsRead";
export const POST_NOTIFICATION_BADGE_ASREAD_SUCCESS = "PostNotificationBadgeAsRead.Success";
export const POST_NOTIFICATION_BADGE_ASREAD_FAILURE = "PostNotificationBadgeAsRead.Failure";
export const GET_USERS_DELETED_POSTS = "GetUsersDeletedPosts";
export const GET_USERS_DELETED_POSTS_SUCCESS = "GetUsersDeletedPosts.Success";
export const GET_USERS_DELETED_POSTS_FAILURE = "GetUsersDeletedPosts.Failure";